import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Logo from "../../../assets/Images/logo.png";
import { FaBars, FaTimes } from "react-icons/fa";
import { ChevronDown } from "lucide-react";

function Navbar() {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();

	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
		setIsMobileDropdownOpen(false);
	};

	const serviceItems = [
		{ label: 'Online Consultation', path: '/find-doctors' },
		{ label: 'Lab Tests', path: '/lab-tests' },
		{ label: 'Health Records', path: '/health-records' },
		{ label: 'Emergency Services', path: '/emergency' },
	];

	return (
		<header className="sticky top-0 w-full bg-white shadow-sm py-3 md:py-0 z-50 border-b border-gray-100">
			<div className="max-w-screen-xl mx-auto flex items-center justify-between h-full">
				<div
					onClick={() => navigate("/")}
					className="flex items-center flex-shrink-0 cursor-pointer">
					<img
						src={Logo}
						alt="Digihealth Logo"
						className="w-[110px] sm:w-[110px] md:w-[130px] lg:w-[140px] xl:w-[160px] h-auto object-contain transition-all duration-300 hover:opacity-90"
					/>
				</div>

				<div className="hidden lg:flex items-center space-x-8 mr-4">
					<nav className="flex space-x-6 text-gray-800 font-medium">
						<NavLink to="/" label="Home" location={location} />
						<NavLink to="/find-doctors" label="Find Doctors" location={location} />
						<NavLink to="/emergency" label="Emergency" location={location} />
						
						{/* <div className="relative group">
							<button className="flex items-center gap-1 py-6 font-medium text-gray-800 hover:text-[#D66B27]">
								Services
								<ChevronDown size={16} />
							</button>

							<div className="absolute left-0 top-full w-56 bg-white shadow-lg rounded-lg border opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
								{serviceItems.map((item, index) => (
									<Link
										key={index}
										to={item.path}
										className="flex items-center px-4 py-3 text-gray-700 hover:pl-6 hover:bg-[#FFF0E6] hover:text-[#D66B27] rounded-lg transition-all group"
									>
										<div className="w-2 h-2 bg-[#D66B27] rounded-full mr-3"></div>
										<span className="font-medium group-hover:translate-x-2 transition-transform">
											{item.label}
										</span>
									</Link>
								))}
							</div>
						</div> */}

						<NavLink to="/blogs" label="Blogs" location={location} />
						<NavLink to="/case-study" label="Case Study" location={location} />
						<NavLink to="/about-us" label="About Us" location={location} />
						<NavLink to="/contact-us" label="Contact" location={location} />
					</nav>

					<button
						onClick={() => navigate("/login")}
						className="bg-orange-500 text-white rounded-lg font-semibold hover:bg-[#bb5617] px-6 py-2">
						Login
					</button>
				</div>

				<div className="lg:hidden flex items-center gap-2">
					<button
						onClick={toggleMenu}
						className="text-gray-700 text-2xl p-2 hover:bg-gray-100 rounded-lg">
						{isMenuOpen ? <FaTimes /> : <FaBars />}
					</button>
				</div>
			</div>

			{isMenuOpen && (
				<div className="lg:hidden fixed inset-x-0 top-[55px] bottom-0 bg-white z-50 shadow-lg overflow-y-auto">

					<nav className="flex flex-col p-6 space-y-2 text-gray-800 font-medium">
						<Link to="/"
							onClick={toggleMenu}
							className="py-3 px-4 border-b">
							Home
						</Link>
						<Link
							to="/find-doctors"
							onClick={toggleMenu}
							className="py-3 px-4 border-b">
							Find Doctors
						</Link>
						<Link
							to="/emergency"
							onClick={toggleMenu}
							className="py-3 px-4 border-b">
							Emergency
						</Link>
						{/* <div className="border-b">
							<button
								onClick={() => setIsMobileDropdownOpen(!isMobileDropdownOpen)}
								className="w-full flex justify-between items-center py-3 px-4"
							>
								<span>Services</span>
								<ChevronDown
									size={16}
									className={`transition-transform ${isMobileDropdownOpen ? "rotate-180" : ""
										}`}
								/>
							</button>

							{isMobileDropdownOpen && (
								<div className="flex flex-col bg-gray-50">
									{serviceItems.map((item, index) => <div className="p-2">
										<Link
											key={index}
											to={item.path}
											onClick={toggleMenu}
											className="pl-8 py-3"
										>
											{item.label}
										</Link>
									</div>)}
								</div>
							)}
						</div> */}

						<Link
							to="/blogs"
							onClick={toggleMenu}
							className="py-3 px-4 border-b">
							Blogs
						</Link>
						<Link
							to="/case-study"
							onClick={toggleMenu}
							className="py-3 px-4 border-b">
							Case Study
						</Link>
						<Link
							to="/about-us"
							onClick={toggleMenu}
							className="py-3 px-4 border-b">
							About Us
						</Link>
						<Link
							to="/contact-us"
							onClick={toggleMenu}
							className="py-3 px-4 border-b">
							Contact
						</Link>

						<button
							onClick={() => {
								toggleMenu();
								navigate("/login");
							}}
							className="bg-[#D66B27] text-white rounded-lg font-semibold hover:bg-[#bb5617] px-6 py-2">
							Login
						</button>
					</nav>
				</div>
			)}
		</header>
	);
}

function NavLink({ to, label, location }) {
	const isActive = location.pathname === to;
	return (
		<Link
			to={to}
			className={`relative group py-6 ${isActive ? "text-[#D66B27] font-semibold" : ""
				}`}>
			{label}
			<span
				className={`absolute bottom-5 left-0 h-[2px] bg-[#D66B27] transition-all duration-300 ${isActive ? "w-full" : "w-0 group-hover:w-full"
					}`}></span>
		</Link>
	);
}


export default Navbar;

